import { signOut } from "firebase/auth";
import { auth } from "../../services/firebaseConfig";

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
export const handleLogout = async (navigate, setToken) => {
  try {
    await signOut(auth);
    sessionStorage.clear();
    // Clear all cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    removeCookie("token");
    if (setToken) setToken(null);
    navigate("/login", { replace: true });
    // window.location.reload() causes a 404 on Render because
    // static file servers don't natively understand React router paths. 
    // State is already cleared.
  } catch (err) {
    console.error("Logout Error:", err);
  }
};
